import React from "react"
import { InfoWindow } from "@react-google-maps/api"

const CustomInfoWindow = ({ position, children, onCloseClick = undefined }) => {
  return (
    <>
      {position && children && (
        <InfoWindow
          position={position}
          options={{ pixelOffset: new window.google.maps.Size(0, -45) }}
          onCloseClick={onCloseClick}
        >
          {children}
        </InfoWindow>
      )}
    </>
  )
}

export default CustomInfoWindow
